// extracted by mini-css-extract-plugin
export var filterIncDec = "_c2-0";
export var leftBorder = "_c2-1";
export var rightBorder = "_c2-2";
export var stringInput = "_c2-3";